(function () {
  'use strict';

  /* Mobile menu */
  function initMenu() {
    const drawer = document.querySelector('.avy-menu-drawer');
    if (!drawer) return;

    const openBtn = document.querySelector('[data-avy-menu-open]');
    const closeBtns = drawer.querySelectorAll('[data-avy-menu-close]');
    const navLinks = drawer.querySelectorAll('.avy-menu-drawer__nav a');

    function open() {
      drawer.classList.add('is-open');
      document.body.classList.add('avy-menu-open');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('avy-menu-open');
      document.body.style.overflow = '';
    }

    openBtn?.addEventListener('click', open);
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    navLinks.forEach(function (link) { link.addEventListener('click', close); });
  }

  /* FAQ accordion */
  function initFaq() {
    document.querySelectorAll('.avy-faq__question, .avy-pdp-faq__question, .avy-pdp__accordion-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const item = btn.closest('.avy-faq__item, .avy-pdp-faq__item, .avy-pdp__accordion');
        if (!item) return;
        const isOpen = item.classList.contains('is-open');
        const parent = item.parentElement;
        parent?.querySelectorAll('.is-open').forEach(function (el) { el.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* Product gallery */
  function initGallery() {
    const gallery = document.querySelector('[data-avy-gallery]');
    if (!gallery) return;

    const mainImg = gallery.querySelector('.avy-pdp__main-image');
    const scroller = gallery.querySelector('.avy-pdp__thumbs');
    const thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.avy-pdp__thumb'));
    let index = Math.max(0, thumbs.findIndex(function (el) { return el.classList.contains('is-active'); }));

    function show(next) {
      if (!thumbs.length) return;
      index = (next + thumbs.length) % thumbs.length;
      thumbs.forEach(function (el, i) { el.classList.toggle('is-active', i === index); });
      const src = thumbs[index].dataset.src;
      if (src && mainImg) {
        mainImg.src = src;
        mainImg.srcset = thumbs[index].dataset.srcset || '';
      }
      if (scroller && thumbs[index].scrollIntoView) {
        thumbs[index].scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });

    const prev = gallery.querySelector('[data-avy-gallery-prev]');
    const next = gallery.querySelector('[data-avy-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
  }

  function checkoutUrl() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'checkout';
  }

  function shouldAddPackageProtectionOnCheckout() {
    const cfg = window.pureCartPackageProtection;
    return !!(cfg && cfg.enabled && cfg.autoAdd === true && cfg.onCheckout !== false && cfg.variantId);
  }

  function ensurePackageProtectionOnCheckout() {
    if (typeof window.pureCartEnsurePackageProtection === 'function') {
      return window.pureCartEnsurePackageProtection();
    }

    if (!shouldAddPackageProtectionOnCheckout()) return Promise.resolve(false);
    if (sessionStorage.getItem('pure_cart_pp_declined') === '1') return Promise.resolve(false);

    const variantId = Number(window.pureCartPackageProtection.variantId);
    if (!variantId) return Promise.resolve(false);

    const cartJs = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    const config = typeof fetchConfig === 'function' ? fetchConfig() : {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    };

    return fetch(cartJs)
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return false;
        if (cart.items.some(function (item) { return Number(item.variant_id) === variantId; })) return true;
        return fetch(addUrl, Object.assign({}, config, {
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        }))
          .then(function (response) { return response.json(); })
          .then(function (state) { return !(state && state.status); });
      })
      .catch(function () { return false; });
  }

  function goToCheckout() {
    window.location.href = checkoutUrl();
  }

  function afterAddToCartDestination(form) {
    if (!form) return 'checkout';
    const behavior = form.dataset.avyCartBehavior || 'theme_default';
    if (behavior === 'checkout' || behavior === 'drawer' || behavior === 'page') return behavior;

    const themeAction = form.dataset.themeAtcAction || 'checkout';
    if (themeAction === 'checkout' || themeAction === 'drawer') return themeAction;

    const themeCartType = form.dataset.themeCartType || 'drawer';
    return themeCartType === 'drawer' ? 'drawer' : 'page';
  }

  function shouldOpenCartDrawer(form) {
    return afterAddToCartDestination(form) === 'drawer';
  }

  function isUsableVariantId(value) {
    if (value == null) return false;
    const raw = String(value).trim();
    if (!raw || raw === 'undefined' || raw === 'null') return false;
    const numeric = Number(raw);
    return Number.isFinite(numeric) && numeric > 0;
  }

  function cartAddSucceeded(data) {
    if (!data || data.status) return false;
    if (data.id || data.variant_id || data.product_id) return true;
    return !!(data.items && data.items.length);
  }

  function cartSectionsUrl() {
    return window.location.pathname;
  }

  function isCartDrawerOpen() {
    const cart = document.querySelector('cart-drawer');
    return !!(cart && (cart.classList.contains('active') || cart.classList.contains('animate')));
  }

  function openCartDrawer(btn) {
    const cart = document.querySelector('cart-drawer');
    if (!cart) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }

    cart.classList.remove('is-empty');
    if (typeof cart.open === 'function') {
      cart.open(btn || undefined);
    }
  }

  function appendCartSections(formData, cart) {
    if (!cart || typeof cart.getSectionsToRender !== 'function' || !formData) return;
    formData.append(
      'sections',
      cart.getSectionsToRender().map(function (section) { return section.id; }).join(',')
    );
    formData.append('sections_url', cartSectionsUrl());
  }

  function refreshCartSections(cart, data) {
    if (data && data.sections && data.sections['cart-drawer'] && typeof cart.renderContents === 'function') {
      try {
        cart.renderContents(data);
        return Promise.resolve(true);
      } catch (err) {
        console.error(err);
      }
    }

    const ids = cart && typeof cart.getSectionsToRender === 'function'
      ? cart.getSectionsToRender().map(function (section) { return section.id; }).join(',')
      : 'cart-drawer,cart-icon-bubble';
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    return fetch(root + '?sections=' + encodeURIComponent(ids), {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        if (!sections || typeof sections !== 'object') return false;
        if (typeof cart.renderContents === 'function') {
          cart.renderContents(Object.assign({}, data || {}, { sections: sections }));
        }
        return true;
      })
      .catch(function (err) {
        console.error(err);
        return false;
      });
  }

  function handleCartAddSuccess(form, btn, data) {
    window.__avyCartAddSeen = Date.now();

    const destination = afterAddToCartDestination(form);
    const cart = document.querySelector('cart-drawer');
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';

    if (destination === 'checkout') {
      const redirectAge = Date.now() - (window.__avyCheckoutRedirectAt || 0);
      if (window.__avyCheckoutRedirectStarted && redirectAge < 4000) return;
      window.__avyCheckoutRedirectStarted = true;
      window.__avyCheckoutRedirectAt = Date.now();

      if (!shouldAddPackageProtectionOnCheckout()) {
        goToCheckout();
        return;
      }

      const checkoutTimer = window.setTimeout(goToCheckout, 2500);
      ensurePackageProtectionOnCheckout().finally(function () {
        window.clearTimeout(checkoutTimer);
        goToCheckout();
      });
      return;
    }

    if (destination !== 'drawer') {
      window.location.href = cartUrl;
      return;
    }

    if (!cart) {
      window.location.href = cartUrl;
      return;
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'avy-product-form',
        productVariantId: data && (data.id || data.variant_id),
        cartData: data,
      });
    }

    cart.classList.remove('is-empty');

    Promise.resolve(refreshCartSections(cart, data)).finally(function () {
      openCartDrawer(btn);
    });
  }

  function initAvyCartBridge() {
    if (window.__avyCartBridgeInstalled) return;
    window.__avyCartBridgeInstalled = true;

    const nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      const requestUrl = typeof input === 'string' ? input : (input && input.url) || '';
      const isCartAdd = requestUrl.indexOf('/cart/add') !== -1;

      return nativeFetch(input, init).then(function (response) {
        if (!isCartAdd || !response.ok) return response;

        const form = document.querySelector('[data-avy-product-form]');
        if (!form) return response;

        response.clone().json().then(function (data) {
          if (!cartAddSucceeded(data)) return;
          window.__avyCartAddSeen = Date.now();
          if (window.__avyHandlingCartAdd) return;
          handleCartAddSuccess(form, document.querySelector('[data-avy-atc]'), data);
        }).catch(function () {});

        return response;
      });
    };
  }

  function initVariants() {
    const form = document.querySelector('[data-avy-product-form]');
    if (!form) return;

    const atcBtn = form.querySelector('[data-avy-atc]');
    const buyOnceBtn = form.querySelector('[data-avy-buy-once]');
    const fallbackVariantId = form.getAttribute('data-avy-variant-id') || form.querySelector('[name="id"]')?.value || '';

    function atcLabelText(btn) {
      return (btn && btn.getAttribute('data-avy-atc-label')) || 'ADD TO CART';
    }

    function restoreAtcButton(btn) {
      if (!btn) return;
      const wanted = atcLabelText(btn);
      let label = btn.querySelector('.avy-pdp__atc-label');
      if (!label) {
        label = document.createElement('span');
        label.className = 'avy-pdp__atc-label';
        btn.appendChild(label);
      }
      label.textContent = wanted;
      btn.dataset.label = wanted;
    }

    function setAtcError(message) {
      const errEl = form.querySelector('[data-avy-atc-error]');
      if (!errEl) return;
      if (message) {
        errEl.hidden = false;
        errEl.textContent = message;
      } else {
        errEl.hidden = true;
        errEl.textContent = '';
      }
    }

    function initAtcLabelLock() {
      const btn = form.querySelector('[data-avy-atc]');
      if (!btn || btn.dataset.avyAtcLabelLock === 'true') return;
      btn.dataset.avyAtcLabelLock = 'true';

      function ensureLabel() {
        let label = btn.querySelector('.avy-pdp__atc-label');
        if (!label) {
          label = document.createElement('span');
          label.className = 'avy-pdp__atc-label';
          btn.prepend(label);
        }
        return label;
      }

      function enforceLabel() {
        if (btn.disabled && btn.querySelector('.avy-pdp__atc-label')?.textContent === 'Adding...') return;

        const wanted = atcLabelText(btn);
        const label = ensureLabel();
        const text = label.textContent.trim();
        if (text !== wanted && text !== 'Adding...') {
          label.textContent = wanted;
        }

        Array.from(btn.childNodes).forEach(function (node) {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
            node.textContent = '';
          }
        });

        btn.dataset.label = wanted;
      }

      enforceLabel();

      const label = ensureLabel();
      const labelObserver = new MutationObserver(enforceLabel);
      labelObserver.observe(label, { characterData: true, childList: true, subtree: true });

      const buttonObserver = new MutationObserver(enforceLabel);
      buttonObserver.observe(btn, { childList: true });

      const kachingRoot = form.querySelector('kaching-bundle, kaching-bundles-block');
      if (kachingRoot) {
        ['deal-bar-selected', 'variant-selected', 'variants-changed'].forEach(function (eventName) {
          kachingRoot.addEventListener(eventName, enforceLabel);
        });
      }
    }

    function initKachingSupport() {
      const kachingRoot = form.querySelector('kaching-bundle, kaching-bundles-block');
      if (!kachingRoot) return;

      function bindKachingEvents() {
        const root = form.querySelector('kaching-bundle, kaching-bundles-block');
        if (!root || root.dataset.avyKachingBound === 'true') return;
        root.dataset.avyKachingBound = 'true';

        ['deal-bar-selected', 'variant-selected', 'variants-changed'].forEach(function (eventName) {
          root.addEventListener(eventName, function () {
            const label = form.querySelector('.avy-pdp__atc-label');
            const atcBtnLive = form.querySelector('[data-avy-atc]');
            if (label) label.textContent = atcLabelText(atcBtnLive);
          });
        });
      }

      bindKachingEvents();

      if (typeof customElements !== 'undefined' && customElements.whenDefined) {
        customElements.whenDefined('kaching-bundle').then(bindKachingEvents).catch(function () {});
        customElements.whenDefined('kaching-bundles-block').then(bindKachingEvents).catch(function () {});
      }

      const mountObserver = new MutationObserver(bindKachingEvents);
      const mount = form.querySelector('[data-avy-kaching-bundles]');
      if (mount) {
        mountObserver.observe(mount, { childList: true, subtree: true });
      }
    }

    initAtcLabelLock();
    initKachingSupport();

    if (buyOnceBtn && buyOnceBtn.dataset.avyBuyOnceBound !== 'true') {
      buyOnceBtn.dataset.avyBuyOnceBound = 'true';
      buyOnceBtn.addEventListener('click', function () {
        const firstDeal = form.querySelector('[data-deal-bar-id], .kaching-bundles__bar, [class*="deal-bar"]');
        if (firstDeal && typeof firstDeal.click === 'function') {
          firstDeal.click();
        }
      });
    }

    if (form.dataset.avySubmitBound === 'true') return;
    form.dataset.avySubmitBound = 'true';

    function resolveVariantId() {
      const live = form.querySelector('[name="id"]');
      if (live && isUsableVariantId(live.value)) return String(live.value).trim();
      if (isUsableVariantId(form.getAttribute('data-avy-variant-id'))) {
        return String(form.getAttribute('data-avy-variant-id')).trim();
      }
      return isUsableVariantId(fallbackVariantId) ? String(fallbackVariantId).trim() : '';
    }

    function ensureVariantId() {
      const variantId = resolveVariantId();
      if (!variantId) return '';

      let idInput = form.querySelector('[name="id"]');
      if (!idInput) {
        idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        idInput.setAttribute('data-avy-variant-input', '');
        form.prepend(idInput);
      }

      if (!isUsableVariantId(idInput.value)) idInput.value = variantId;
      idInput.disabled = false;
      return idInput.value;
    }

    function submitAvyProductForm(btn) {
      if (window.__avyHandlingCartAdd) return;

      const variantId = ensureVariantId();
      if (!variantId) {
        setAtcError('This product cannot be added to cart yet.');
        return;
      }

      setAtcError('');

      if (btn) {
        btn.disabled = true;
        const label = btn.querySelector('.avy-pdp__atc-label');
        if (label) label.textContent = 'Adding...';
      }

      const cart = document.querySelector('cart-drawer');
      const formData = new FormData(form);
      if (!isUsableVariantId(formData.get('id'))) formData.set('id', variantId);
      if (!formData.get('quantity')) formData.append('quantity', '1');

      const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
      config.headers = Object.assign({}, config.headers, {
        'X-Requested-With': 'XMLHttpRequest',
      });
      delete config.headers['Content-Type'];

      if (cart && shouldOpenCartDrawer(form)) {
        appendCartSections(formData, cart);
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(btn || document.activeElement);
        }
      }

      config.body = formData;
      window.__avyHandlingCartAdd = true;

      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

      fetch(addUrl, config)
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (!cartAddSucceeded(data)) {
            throw new Error((data && (data.description || data.message)) || 'Could not add to cart');
          }

          handleCartAddSuccess(form, btn, data);
        })
        .catch(function (err) {
          console.error(err);
          setAtcError((err && err.message) || 'Could not add to cart');
        })
        .finally(function () {
          window.__avyHandlingCartAdd = false;
          if (!btn) return;
          btn.disabled = false;
          restoreAtcButton(btn);
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      ensureVariantId();
      submitAvyProductForm(atcBtn || form.querySelector('[data-avy-atc]'));
    }, true);

    if (form.dataset.avyClickBound !== 'true') {
      form.dataset.avyClickBound = 'true';
      form.addEventListener('click', function (e) {
        const btn = e.target.closest('[data-avy-atc], [data-add-to-cart]');
        if (!btn || !form.contains(btn)) return;

        ensureVariantId();

        window.setTimeout(function () {
          if (window.__avyHandlingCartAdd) return;
          if (Date.now() - (window.__avyCartAddSeen || 0) < 1500) return;
          if (isCartDrawerOpen()) return;
          submitAvyProductForm(atcBtn || btn);
        }, 450);
      }, true);
    }
  }

  function initPdpStickyBar() {
    const bar = document.querySelector('[data-avy-pdp-sticky]');
    const atc = document.querySelector('.avy-pdp__atc');
    const buybox = document.querySelector('[data-avy-pdp-buybox]');
    if (!bar || !atc) return;

    /* Footer group is z-index 2 above #MainContent (z-index 0). A fixed bar
       inside main is painted under the footer. Keep it on the body instead. */
    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }

    function setVisible(show) {
      bar.classList.toggle('is-visible', show);
      bar.hidden = !show;
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('has-pdp-sticky', show);
      if (show) {
        document.documentElement.style.setProperty('--thy-sticky-h', bar.offsetHeight + 'px');
      }
    }

    function updateVisibility() {
      const rect = atc.getBoundingClientRect();
      setVisible(rect.bottom < 12);
    }

    const scrollBtn = bar.querySelector('[data-avy-sticky-scroll]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', function () {
        const target = buybox || atc;
        const chrome = document.querySelector('.thy-chrome');
        const headerOffset = chrome ? chrome.getBoundingClientRect().height + 12 : 88;
        const top = window.scrollY + target.getBoundingClientRect().top - headerOffset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    updateVisibility();
  }

  /* Evergreen promo countdown — persists in localStorage and auto-resets */
  function initPromoBanner(root) {
    if (!root || root.getAttribute('data-avy-promo-init') === '1') return;

    const hours = parseInt(root.getAttribute('data-duration-hours'), 10) || 4;
    const durationMs = hours * 60 * 60 * 1000;
    const storageKey = root.getAttribute('data-storage-key') || 'avy-promo-timer';
    const hoursEl = root.querySelector('[data-avy-promo-hours]');
    const minsEl = root.querySelector('[data-avy-promo-mins]');
    const secsEl = root.querySelector('[data-avy-promo-secs]');

    if (!hoursEl || !minsEl || !secsEl) return;

    root.setAttribute('data-avy-promo-init', '1');

    function readState() {
      try {
        const raw = localStorage.getItem(storageKey);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    function writeState(endTime) {
      try {
        localStorage.setItem(storageKey, JSON.stringify({
          endTime: endTime,
          durationMs: durationMs
        }));
      } catch (e) {
        /* storage unavailable */
      }
    }

    function getEndTime() {
      const now = Date.now();
      const state = readState();

      if (!state || state.durationMs !== durationMs || typeof state.endTime !== 'number' || state.endTime <= now) {
        const endTime = now + durationMs;
        writeState(endTime);
        return endTime;
      }

      return state.endTime;
    }

    let endTime = getEndTime();
    let timerId = null;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function render() {
      const now = Date.now();
      let remaining = endTime - now;

      if (remaining <= 0) {
        endTime = now + durationMs;
        writeState(endTime);
        remaining = durationMs;
      }

      const totalSecs = Math.floor(remaining / 1000);
      const hrs = Math.floor(totalSecs / 3600);
      const mins = Math.floor((totalSecs % 3600) / 60);
      const secs = totalSecs % 60;

      hoursEl.textContent = pad(hrs);
      minsEl.textContent = pad(mins);
      secsEl.textContent = pad(secs);
    }

    function start() {
      render();
      if (timerId) clearInterval(timerId);
      timerId = setInterval(render, 1000);
    }

    function stop() {
      if (timerId) {
        clearInterval(timerId);
        timerId = null;
      }
    }

    start();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        endTime = getEndTime();
        start();
      }
    });
  }

  function initAllPromoBanners() {
    document.querySelectorAll('[data-avy-promo-banner]').forEach(initPromoBanner);
  }

  function initVerifiedReviews(root) {
    if (!root || root.getAttribute('data-avy-verified-init') === '1') return;

    var track = root.querySelector('.avy-verified-reviews__track');
    var cards = track ? Array.from(track.querySelectorAll('.avy-verified-review-card')) : [];
    var prev = root.querySelector('[data-avy-verified-prev]');
    var next = root.querySelector('[data-avy-verified-next]');
    if (!track || !cards.length) return;

    root.setAttribute('data-avy-verified-init', '1');

    var index = 0;

    function getVisible() {
      var slots = 1;
      if (window.innerWidth >= 750) slots = 2;
      if (window.innerWidth >= 1200) slots = 3;
      return Math.min(slots, cards.length);
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function getCardOffset(card) {
      return card.getBoundingClientRect().left - track.getBoundingClientRect().left;
    }

    function update() {
      var maxIndex = getMaxIndex();
      if (index > maxIndex) index = maxIndex;

      var card = cards[index];
      if (card) {
        track.style.transform = 'translate3d(-' + getCardOffset(card) + 'px, 0, 0)';
      }

      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= maxIndex;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        if (index > 0) {
          index -= 1;
          update();
        }
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        if (index < getMaxIndex()) {
          index += 1;
          update();
        }
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(update, 100);
    });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(update).observe(track);
    }

    requestAnimationFrame(function () {
      update();
      requestAnimationFrame(update);
    });
    window.addEventListener('load', update);
  }

  function initAllVerifiedReviews() {
    document.querySelectorAll('[data-avy-verified-reviews]').forEach(initVerifiedReviews);
  }

  function initThyReasons(root) {
    if (!root || root.getAttribute('data-thy-reasons-init') === '1') return;

    var track = root.querySelector('.thy-reasons__track');
    var cards = track ? Array.from(track.querySelectorAll('.thy-reasons__card')) : [];
    var prev = root.querySelector('[data-thy-reasons-prev]');
    var next = root.querySelector('[data-thy-reasons-next]');
    var dotsWrap = root.querySelector('[data-thy-reasons-dots]');
    var nav = root.querySelector('.thy-reasons__nav');
    if (!track || !cards.length) return;

    root.setAttribute('data-thy-reasons-init', '1');

    var index = 0;
    var pageCount = 0;

    function visibleCount() {
      if (window.innerWidth >= 990) return Math.min(3, cards.length);
      if (window.innerWidth >= 750) return Math.min(2, cards.length);
      return 1;
    }

    function maxIndex() {
      return Math.max(0, cards.length - visibleCount());
    }

    function renderDots() {
      if (!dotsWrap) return;
      var pages = maxIndex() + 1;
      if (pages === pageCount && dotsWrap.children.length === pages) {
        Array.from(dotsWrap.children).forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
        return;
      }
      pageCount = pages;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'thy-reasons__dot' + (i === index ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Show reasons starting at ' + (i + 1));
        dot.addEventListener('click', (function (n) {
          return function () {
            index = n;
            update();
          };
        })(i));
        dotsWrap.appendChild(dot);
      }
      if (nav) nav.hidden = pages <= 1;
    }

    function update() {
      var max = maxIndex();
      if (index > max) index = max;
      if (index < 0) index = 0;
      var card = cards[index];
      if (card) {
        var offset = card.getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';
      }
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= max;
      renderDots();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        if (index > 0) {
          index -= 1;
          update();
        }
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        if (index < maxIndex()) {
          index += 1;
          update();
        }
      });
    }

    var startX = 0;
    var viewport = root.querySelector('.thy-reasons__viewport');
    if (viewport) {
      viewport.addEventListener('pointerdown', function (event) {
        startX = event.clientX;
      });
      viewport.addEventListener('pointerup', function (event) {
        var delta = event.clientX - startX;
        if (delta > 48 && index > 0) {
          index -= 1;
          update();
        } else if (delta < -48 && index < maxIndex()) {
          index += 1;
          update();
        }
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(update, 100);
    });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(update).observe(track);
    }

    requestAnimationFrame(function () {
      update();
      requestAnimationFrame(update);
    });
    window.addEventListener('load', update);
  }

  function initAllThyReasons() {
    document.querySelectorAll('[data-thy-reasons]').forEach(initThyReasons);
  }

  function removePackageProtectionFromCart(variantId) {
    const cartJs = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    const changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    const config = typeof fetchConfig === 'function' ? fetchConfig() : {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    };

    return fetch(cartJs)
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        const hasLine = cart && cart.items && cart.items.some(function (item) {
          return Number(item.variant_id) === variantId;
        });
        if (!hasLine) return null;
        return fetch(changeUrl, Object.assign({}, config, {
          body: JSON.stringify({ id: String(variantId), quantity: 0 }),
        })).then(function (response) { return response.json(); });
      })
      .catch(function () { return null; });
  }

  function initPdpPackageProtection() {
    document.querySelectorAll('[data-avy-pp]').forEach(function (root) {
      if (root.dataset.avyPpInit) return;
      root.dataset.avyPpInit = '1';

      const input = root.querySelector('[data-avy-pp-input]');
      const variantId = Number(root.dataset.variantId);
      if (!input || !variantId) return;

      input.checked = sessionStorage.getItem('pure_cart_pp_declined') !== '1';

      input.addEventListener('change', function () {
        if (input.checked) {
          sessionStorage.removeItem('pure_cart_pp_declined');
          return;
        }
        sessionStorage.setItem('pure_cart_pp_declined', '1');
        removePackageProtectionFromCart(variantId).then(function (state) {
          if (state && !state.status && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'avy-pdp-package-protection', cartData: state });
          }
        });
      });
    });
  }

  window.addEventListener('pageshow', function () {
    window.__avyCheckoutRedirectStarted = false;
    window.__avyCheckoutRedirectAt = 0;
    window.__avyHandlingCartAdd = false;

    document.querySelectorAll('[data-avy-atc]').forEach(function (btn) {
      btn.disabled = false;
      const label = btn.querySelector('.avy-pdp__atc-label');
      const wanted = btn.getAttribute('data-avy-atc-label');
      if (label && wanted) label.textContent = wanted;
    });
  });

  function boot() {
    initAvyCartBridge();
    initMenu();
    initFaq();
    initGallery();
    initVariants();
    initPdpStickyBar();
    initAllPromoBanners();
    initAllVerifiedReviews();
    initAllThyReasons();
    initPdpPackageProtection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-avy-product-form]')) {
      initVariants();
      initPdpPackageProtection();
    }

    event.target.querySelectorAll('[data-avy-promo-banner]').forEach(function (banner) {
      banner.removeAttribute('data-avy-promo-init');
      initPromoBanner(banner);
    });

    event.target.querySelectorAll('[data-avy-verified-reviews]').forEach(function (section) {
      section.removeAttribute('data-avy-verified-init');
      initVerifiedReviews(section);
    });

    event.target.querySelectorAll('[data-thy-reasons]').forEach(function (section) {
      section.removeAttribute('data-thy-reasons-init');
      initThyReasons(section);
    });
  });
})();
